import { ArrowLeft, ArrowRight, BrainCircuit, CheckCircle2 } from 'lucide-react';
import { CASE_001 } from '../case/case001';
import { useGame } from '../game/GameContext';

export function TheoryScreen() {
  const { state, dispatch } = useGame();
  const complete = CASE_001.theory.every((section) => state.theory[section.key]);
  return (
    <main className="theory-screen screen-layer">
      <header>
        <button className="icon-action" onClick={() => dispatch({ type: 'START_TRIAL' })}><ArrowLeft /></button>
        <div><span>COUNSEL RECONSTRUCTION</span><h1>Make the hidden sequence provable.</h1></div>
        <div className="theory-screen__confidence"><BrainCircuit /><span>Record confidence</span><strong>{state.contradictionsFound.length * 20}%</strong></div>
      </header>
      <div className="theory-screen__timeline"><i /><b /><span>20:48</span><span>21:05</span><span>21:10</span><span>21:17</span></div>
      <section className="theory-sections">
        {CASE_001.theory.map((section, index) => (
          <article key={section.key} className="theory-section">
            <div className="theory-section__index">0{index + 1}</div>
            <div className="theory-section__question"><span>{section.label}</span><h2>{section.question}</h2></div>
            <div className="theory-section__options">
              {section.options.map((option) => {
                const selected = state.theory[section.key] === option.id;
                return (
                  <button key={option.id} className={selected ? 'is-selected' : ''} onClick={() => dispatch({ type: 'SET_THEORY', key: section.key, optionId: option.id })}>
                    <i>{selected && <CheckCircle2 />}</i><span><strong>{option.label}</strong><small>{option.description}</small></span>
                  </button>
                );
              })}
            </div>
          </article>
        ))}
      </section>
      <footer>
        <p>The tribunal will judge the theory you can support—not the truth you merely suspect.</p>
        <button className="primary-action primary-action--large" disabled={!complete} onClick={() => dispatch({ type: 'SUBMIT_THEORY' })}>Commit theory to record <ArrowRight /></button>
      </footer>
    </main>
  );
}
